// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2oN2D","form":"style_form__g8iL8","container--desktop":"style_container--desktop__1QDuu"};